
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import landscape from "../lib/images/Logorm.png";

const LOGO_HORIZONTAL = landscape;

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Contact", path: "/contact" },
];

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  // Lock scroll when menu open
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
  }, [mobileMenuOpen]);

  return (
    <>
      {/* NAVBAR */}
      <nav
        className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-md border-b border-slate-200"
        data-testid="navbar"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center gap-2 Logoarea"
              data-testid="navbar-logo"
            >
              <img
                src={LOGO_HORIZONTAL}
                alt="Causaler"
                className="h-7 w-auto"
              />
              <div className="causaler">CAUSALER</div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-medium transition-colors ${
                    isActive(link.path)
                      ? "text-[#F5941E]"
                      : "text-slate-600 hover:text-[#F5941E]"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden md:block">
              <Link to="/contact#contact-form">
                <Button className="h-16 w-64 bg-[#F5941E] hover:bg-[#D97F12] text-white text-xl rounded-full px-6 py-2 font-semibold shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 transition-all">
                  Get Started
                </Button>
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition"
              onClick={() => setMobileMenuOpen(true)}
              aria-label="Open menu"
            >
              <Menu className="w-6 h-6 text-slate-700" />
            </button>
          </div>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div
        className={`fixed inset-0 z-[60] md:hidden transition-opacity duration-300 ${
          mobileMenuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        {/* Blur Background */}
        <div
          className="absolute inset-0 bg-black/30 backdrop-blur-md"
          onClick={() => setMobileMenuOpen(false)}
        />

        {/* Slide Panel */}
        <div
          className={`absolute right-0 top-0 h-full w-80 max-w-[85%] bg-white shadow-2xl p-6 overflow-y-auto transform transition-transform duration-300 ${
            mobileMenuOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex justify-between items-center mb-8">
            <div className="flex items-center gap-2 Logoarea">
              <img
                src={LOGO_HORIZONTAL}
                alt="Causaler"
                className="h-7 w-auto"
              />
              <div className="causaler">CAUSALER</div>
            </div>

            <button
              onClick={() => setMobileMenuOpen(false)}
              className="p-2 rounded-lg hover:bg-slate-100 transition"
              aria-label="Close menu"
            >
              <X className="w-6 h-6 text-slate-700" />
            </button>
          </div>

          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`px-4 py-3 rounded-xl font-medium transition ${
                  isActive(link.path)
                    ? "bg-orange-50 text-[#F5941E]"
                    : "text-slate-600 hover:bg-slate-50"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="mt-8">
            <Link to="/contact#contact-form2" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-[#F5941E] hover:bg-[#D97F12] text-white rounded-full py-3 font-semibold">
                Get Started
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
